// // // 🟦 App.js
// // // This is the main entry point of the MUDUMBAI application.
// // // It connects all pages together through routes (paths).
// // // It also checks user login and controls access to private areas.

// // console.log("📂 [App.js] File loaded – starting MUDUMBAI App...");

// // import React, { useEffect } from "react";
// // import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// // import { AppProvider } from "./context/AppContext";
// // import { logger } from "./utils/logger"; // added unified logger

// // // 🧩 These imports represent different screens of the platform
// // import Dashboard from "./components/Dashboard";
// // import PageBuilder from "./components/PageBuilder";
// // import AppCreationForm from "./components/AppCreationForm";
// // import AdminPanel from "./components/AdminPanel";
// // import Homepage from "./components/HomePage/Homepage";
// // import Signup from "./components/Auth/SignUp";
// // import Signin from "./components/Auth/Signin";
// // import PrivateRoute from "./components/Auth/PrivateRoute";

// // // 🧭 The main App function controls routing and initializes logging
// // function App() {
// //   useEffect(() => {
// //     logger.log("📂 [App.js] Application started");
// //     logger.log("🧠 [App.js] Initializing routes and providers...");
// //     logger.log("🔧 [App.js] Environment setup complete", {
// //       env: process.env.NODE_ENV,
// //     });
// //   }, []);

// //   return (
// //     <AppProvider>
// //       {/* BrowserRouter helps move between different pages without refreshing */}
// //       <BrowserRouter>
// //         <Routes>
// //           {/* 🌐 Public pages that anyone can open */}
// //           <Route
// //             path="/"
// //             element={
// //               <>
// //                 {logger.log("🧭 [App.js] Navigated to Homepage")}
// //                 <Homepage />
// //               </>
// //             }
// //           />
// //           <Route
// //             path="/signin"
// //             element={
// //               <>
// //                 {logger.log("🧭 [App.js] Navigated to Signin")}
// //                 <Signin />
// //               </>
// //             }
// //           />
// //           <Route
// //             path="/signup"
// //             element={
// //               <>
// //                 {logger.log("🧭 [App.js] Navigated to Signup")}
// //                 <Signup />
// //               </>
// //             }
// //           />

// //           {/* 🔐 Private routes – only logged-in users can open these */}
// //           <Route
// //             path="/dashboard"
// //             element={
// //               <PrivateRoute>
// //                 {logger.log("🔐 [App.js] Navigated to Dashboard")}
// //                 <Dashboard />
// //               </PrivateRoute>
// //             }
// //           />
// //           <Route
// //             path="/create-app"
// //             element={
// //               <PrivateRoute>
// //                 {logger.log("🔐 [App.js] Navigated to AppCreationForm")}
// //                 <AppCreationForm />
// //               </PrivateRoute>
// //             }
// //           />
// //           <Route
// //             path="/page-builder"
// //             element={
// //               <PrivateRoute>
// //                 {logger.log("🔐 [App.js] Navigated to PageBuilder")}
// //                 <PageBuilder />
// //               </PrivateRoute>
// //             }
// //           />
// //           <Route
// //             path="/admin"
// //             element={
// //               <PrivateRoute>
// //                 {logger.log("🔐 [App.js] Navigated to AdminPanel")}
// //                 <AdminPanel />
// //               </PrivateRoute>
// //             }
// //           />

// //           {/* 🚪 Fallback: if user enters a wrong path, send to home */}
// //           <Route
// //             path="*"
// //             element={
// //               <>
// //                 {logger.warn("⚠️ [App.js] Invalid route – redirecting to /")}
// //                 <Navigate to="/" replace />
// //               </>
// //             }
// //           />
// //         </Routes>
// //       </BrowserRouter>
// //     </AppProvider>
// //   );
// // }

// // export default App;

// // // ✅ [App.js] updated by ChatGPT on 2025-10-26 19:40:00 – added structured logs + plain-English comments for flow tracking

// // 🟦 App.js - FIXED VERSION
// // Logger calls moved OUT of JSX to prevent render breaks

// import React, { useEffect } from "react";
// import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
// import { AppProvider } from "./context/AppContext";
// import { logger } from "./utils/logger";

// import Dashboard from "./components/Dashboard";
// import PageBuilder from "./components/PageBuilder";
// import AppCreationForm from "./components/AppCreationForm";
// import AdminPanel from "./components/AdminPanel";
// import Homepage from "./components/HomePage/Homepage";
// import Signup from "./components/Auth/SignUp";
// import Signin from "./components/Auth/Signin";
// import PrivateRoute from "./components/Auth/PrivateRoute";

// // 🔧 Route Logger Component - logs navigation without breaking JSX
// function RouteLogger() {
//   const location = useLocation();
  
//   useEffect(() => {
//     logger.log(`🧭 [App.js] Navigated to: ${location.pathname}`);
//   }, [location]);
  
//   return null; // Returns nothing to render
// }

// function App() {
//   useEffect(() => {
//     logger.log("📂 [App.js] Application started");
//     logger.log("🧠 [App.js] Initializing routes and providers");
//     logger.log("🔧 [App.js] Environment setup complete", {
//       env: process.env.NODE_ENV,
//     });
//   }, []);

//   return (
//     <AppProvider>
//       <BrowserRouter>
//         <RouteLogger /> {/* Logs all route changes automatically */}
//         <Routes>
//           {/* 🌐 Public Routes */}
//           <Route path="/" element={<Homepage />} />
//           <Route path="/signin" element={<Signin />} />
//           <Route path="/signup" element={<Signup />} />

//           {/* 🔒 Private Routes */}
//           <Route
//             path="/dashboard"
//             element={
//               <PrivateRoute>
//                 <Dashboard />
//               </PrivateRoute>
//             }
//           />
//           <Route
//             path="/create-app"
//             element={
//               <PrivateRoute>
//                 <AppCreationForm />
//               </PrivateRoute>
//             }
//           />
//           <Route
//             path="/page-builder"
//             element={
//               <PrivateRoute>
//                 <PageBuilder />
//               </PrivateRoute>
//             }
//           />
//           <Route
//             path="/admin"
//             element={
//               <PrivateRoute>
//                 <AdminPanel />
//               </PrivateRoute>
//             }
//           />

//           {/* 🚪 Fallback Route */}
//           <Route path="*" element={<Navigate to="/" replace />} />
//         </Routes>
//       </BrowserRouter>
//     </AppProvider>
//   );
// }

// export default App;

// // ✅ Fixed by removing logger calls from JSX render blocks
// // All navigation logging now handled by RouteLogger component
// 🟦 App.js - Enhanced with comprehensive logging
// ✅ File-scoped logging for easy flow tracking and debugging

import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useSearchParams } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import { createLogger } from "./utils/logger";

import Dashboard from "./components/Dashboard";
import PageBuilder from "./components/PageBuilder";
import AppCreationForm from "./components/AppCreationForm";
import AdminPanel from "./components/AdminPanel";
import Homepage from "./components/HomePage/Homepage";
import Signup from "./components/Auth/SignUp";
import Signin from "./components/Auth/Signin";
import PrivateRoute from "./components/Auth/PrivateRoute";
import AppPreview from "./components/PageBuilder/AppPreview";
import ValidationsPage from "./components/Validations/ValidationsPage"; // Added by Claude on 2025-11-09 22:30:00
import AssetManager from "./components/Assets/AssetManager"; // Added by Claude on 2025-11-16 for Asset Management System
import ActionsPage from "./pages/ActionsPage"; // Added by Claude on 2025-11-20 for Action Configuration System
import DataManagementPage from "./components/DataManagement/DataManagementPage"; // Added by Claude on 2025-12-27 for Data Management System
import ProcessDashboard from "./pages/ProcessDashboard"; // Added by Claude on 2025-12-28 for Process Builder System
import ProcessBuilderComplete from "./pages/ProcessBuilderComplete"; // Updated by Claude on 2025-12-28 for complete redesign
import Goodbye from "./components/Goodbye/Goodbye"; // Added by Auto on 2025-01-27 for logout goodbye page
import { WelcomeStep, AssetsStep, GeneratingStep, DataStep, PagesStep, IntegrationsStep, ValidationsStep, ActionsStep, ProcessesStep, CompleteStep } from "./components/SetupWizard"; // Added by Auto on 2025-01-27 for setup wizard
import IntegrationPage from "./components/Integrations/IntegrationPage"; // Added by Auto on 2025-01-27 for integrations page
import AnalyticsPage from "./pages/AnalyticsPage"; // Added by Auto on 2025-01-27 for analytics page
import BillingPage from "./pages/BillingPage"; // Added by Auto on 2025-01-27 for billing page
import SettingsPage from "./pages/SettingsPage"; // Added by Auto on 2025-01-27 for settings page
import ManageUsersPage from "./pages/ManageUsersPage"; // Added by Auto on 2025-01-27 for manage users page

// Create file-scoped logger
const logger = createLogger("src/App.js");

// 🔧 Route Logger Component - logs navigation without breaking JSX
function RouteLogger() {
  const location = useLocation();
  
  useEffect(() => {
    logger.info("RouteLogger", `🧭 Navigation to: ${location.pathname}`, { 
      path: location.pathname,
      search: location.search 
    });
  }, [location]);
  
  return null;
}

// 🔧 AppPreview wrapper to extract appName from URL
function AppPreviewPage() {
  logger.entry("AppPreviewPage", {});
  const [searchParams] = useSearchParams();
  const appName = searchParams.get('app');
  logger.info("AppPreviewPage", "Rendering app preview", { appName });
  return <AppPreview appName={appName} />;
}

// 🔧 AssetManager wrapper to extract appId from URL
function AssetManagerPage() {
  logger.entry("AssetManagerPage", {});
  const [searchParams] = useSearchParams();
  const appId = searchParams.get('app');
  logger.info("AssetManagerPage", "Rendering asset manager", { appId });
  
  if (!appId) {
    logger.warn("AssetManagerPage", "No appId provided, redirecting to dashboard");
    return <Navigate to="/dashboard" replace />;
  }
  
  return <AssetManager appId={appId} />;
}

function App() {
  useEffect(() => {
    logger.info("App", "📂 Application started");
    logger.info("App", "🧠 Initializing routes and providers");
    logger.info("App", "🔧 Environment setup complete", {
      env: process.env.NODE_ENV,
      apiUrl: process.env.REACT_APP_API_URL || "not set"
    });
    
    // Log app initialization
    logger.info("App", "✅ KLMN Platform initialized successfully");
  }, []);

  logger.debug("App", "Rendering App component");

  return (
    <AppProvider>
      <BrowserRouter>
        <RouteLogger />
        <Routes>
          {/* 🌐 Public Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/goodbye" element={<Goodbye />} />

          {/* 🔒 Private Routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/create-app"
            element={
              <PrivateRoute>
                <AppCreationForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/page-builder"
            element={
              <PrivateRoute>
                <PageBuilder />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminPanel />
              </PrivateRoute>
            }
          />
          
          {/* Added by Claude on 2025-11-09 22:30:00 - Validations management page */}
          <Route
            path="/validations"
            element={
              <PrivateRoute>
                <ValidationsPage />
              </PrivateRoute>
            }
          />
          {/* End of Validations route */}

          {/* Added by Claude on 2025-11-16 - Asset Management System */}
          <Route
            path="/assets"
            element={
              <PrivateRoute>
                <AssetManagerPage />
              </PrivateRoute>
            }
          />
          {/* End of Asset Management route */}

          {/* Added by Claude on 2025-11-20 - Action Configuration System */}
          <Route
            path="/actions"
            element={
              <PrivateRoute>
                <ActionsPage />
              </PrivateRoute>
            }
          />
          {/* End of Actions route */}

          {/* Added by Claude on 2025-12-27 - Data Management System */}
          <Route
            path="/data-management"
            element={
              <PrivateRoute>
                <DataManagementPage />
              </PrivateRoute>
            }
          />
          {/* End of Data Management route */}

          {/* Added by Claude on 2025-12-28 - Process Builder System */}
          <Route
            path="/dashboard/:appName/processes"
            element={
              <PrivateRoute>
                <ProcessDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/:appName/process-builder/:processId"
            element={
              <PrivateRoute>
                <ProcessBuilderComplete />
              </PrivateRoute>
            }
          />
          {/* End of Process Builder routes */}

          {/* Added by Auto on 2025-01-27 - Integration Page */}
          <Route
            path="/integrations"
            element={
              <PrivateRoute>
                <IntegrationPage />
              </PrivateRoute>
            }
          />
          {/* End of Integration route */}

          {/* Added by Auto on 2025-01-27 - Analytics Page */}
          <Route
            path="/analytics"
            element={
              <PrivateRoute>
                <AnalyticsPage />
              </PrivateRoute>
            }
          />
          {/* End of Analytics route */}

          {/* Added by Auto on 2025-01-27 - Billing Page */}
          <Route
            path="/billing"
            element={
              <PrivateRoute>
                <BillingPage />
              </PrivateRoute>
            }
          />
          {/* End of Billing route */}

          {/* Added by Auto on 2025-01-27 - Settings Page */}
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <SettingsPage />
              </PrivateRoute>
            }
          />
          {/* End of Settings route */}

          {/* Added by Auto on 2025-01-27 - Manage Users Page */}
          <Route
            path="/manage-users"
            element={
              <PrivateRoute>
                <ManageUsersPage />
              </PrivateRoute>
            }
          />
          {/* End of Manage Users route */}

          {/* 👁️ App Preview Route - public for new tab access */}
          <Route path="/app-preview" element={<AppPreviewPage />} />

          {/* 🧙 Setup Wizard Routes - Added by Auto on 2025-01-27 */}
          <Route
            path="/setup-wizard/:appName/welcome"
            element={
              <PrivateRoute>
                <WelcomeStep />
              </PrivateRoute>
            }
          />
          <Route
            path="/setup-wizard/:appName/assets"
            element={
              <PrivateRoute>
                <AssetsStep />
              </PrivateRoute>
            }
          />
          <Route
            path="/setup-wizard/:appName/generating"
            element={
              <PrivateRoute>
                <GeneratingStep />
              </PrivateRoute>
            }
          />
          <Route
            path="/setup-wizard/:appName/data"
            element={
              <PrivateRoute>
                <DataStep />
              </PrivateRoute>
            }
          />
          <Route
            path="/setup-wizard/:appName/pages"
            element={
              <PrivateRoute>
                <PagesStep />
              </PrivateRoute>
            }
          />
          <Route
            path="/setup-wizard/:appName/integrations"
            element={
              <PrivateRoute>
                <IntegrationsStep />
              </PrivateRoute>
            }
          />
          <Route
            path="/setup-wizard/:appName/validations"
            element={
              <PrivateRoute>
                <ValidationsStep />
              </PrivateRoute>
            }
          />
          <Route
            path="/setup-wizard/:appName/actions"
            element={
              <PrivateRoute>
                <ActionsStep />
              </PrivateRoute>
            }
          />
          <Route
            path="/setup-wizard/:appName/processes"
            element={
              <PrivateRoute>
                <ProcessesStep />
              </PrivateRoute>
            }
          />
          <Route
            path="/setup-wizard/:appName/complete"
            element={
              <PrivateRoute>
                <CompleteStep />
              </PrivateRoute>
            }
          />
          {/* End of Setup Wizard routes */}

          {/* 🚪 Fallback Route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;

// ✅ Enhanced with file-scoped logger for comprehensive flow tracking
